import styled, { Icon } from "grabcad-ui-elements";

export const Banner = styled.div`
    background: #ebeff7;
    border: 1px solid #003393;
    padding: 10px;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 15px;
    margin-top: 15px;
    display: flex;
    justify-content: space-between; /* Pushes button to the right */
    align-items: center; /* Aligns text and button vertically */
`;

export const BannerContent = styled.div`
    display: flex;
    align-items: center; /* Aligns icon and text on the same line */
    gap: 10px; /* Adds space between icon and text */
`;

export const BannerIcon = styled(Icon)`
    color: #4183c4;
`;
